import script from "./Step.vue?vue&type=script&setup=true&lang=js"
export * from "./Step.vue?vue&type=script&setup=true&lang=js"

import "./Step.vue?vue&type=style&index=0&id=21a3de64&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21a3de64"]])

export default __exports__